import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container py-5 text-center">
          <h1>משהו השתבש</h1>
          <p>אנא נסה לרענן את הדף או חזור לדף הבית.</p>
          <a href="/" className="btn btn-primary">
            חזרה לדף הבית
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
